/**
 * Catálogo de agentes nocivos (#417) — leitura, e só.
 *
 * A busca varre os 400 agentes por rótulo, número CAS e código do eSocial. A ficha vem
 * numa resposta só: o agente, o rótulo do anexo da NR-15 e todas as opções de limite de
 * tolerância com a norma de origem de cada uma. É norma pública, igual para todo tenant.
 */
import apiClient from './apiClient';

export interface HazardousAgentSummary {
  id: number;
  sourceKey: string;
  displayName: string;
  name: string;
  activity: string | null;
  casNumber: string | null;
  esocialCode: string | null;
  inssAgentCode: string | null;
  family: string | null;
  specialRetirementYears: number | null;
  nr15Annex: number | null;
  unhealthyDegree: string | null;
  degreeNote: string | null;
  hygieneStandards: string | null;
  /**
   * A metodologia que a NORMA prescreve para o agente (#464), e não o estágio da empresa: a
   * técnica por extenso, o fundamento normativo, as vias de penetração e o código GFIP.
   * Opcionais porque o catálogo só as tem nos agentes previdenciários.
   */
  assessmentTypeNaFonte?: string | null;
  assessmentBasis?: string | null;
  penetrationRoutes?: string | null;
  gfipCode?: number | null;
  toleranceLimitNote: string | null;
  status: 'ACTIVE' | 'INACTIVE';
}

/**
 * Uma opção de limite. São 436 opções para 229 agentes: o mesmo agente aparece com
 * limites de normas diferentes, e qual vale depende do laboratório que mediu.
 */
export interface HazardousAgentToleranceLimit {
  id: number;
  toleranceLimit: string;
  measurementUnit: string | null;
  source: string | null;
}

export interface HazardousAgentSheet extends HazardousAgentSummary {
  nr15AnnexLabel: string | null;
  toleranceLimits: HazardousAgentToleranceLimit[];
}

class HazardousAgentService {
  private baseUrl = '/hazardous-agents';

  async search(query: string, limit = 20): Promise<HazardousAgentSummary[]> {
    const response = await apiClient.get(
      `${this.baseUrl}/search?q=${encodeURIComponent(query)}&limit=${limit}`
    );
    return response.data?.data ?? response.data;
  }

  async getSheet(id: number | string): Promise<HazardousAgentSheet> {
    const response = await apiClient.get(`${this.baseUrl}/${id}`);
    return response.data?.data ?? response.data;
  }
}

export const hazardousAgentService = new HazardousAgentService();
export default hazardousAgentService;
